/* eslint-disable @typescript-eslint/no-explicit-any */
import { AnyAction } from 'redux';
import { all, getContext, put, takeEvery } from 'redux-saga/effects';
import { DashboardService } from '../service';
import {
	getActiveUsersCounts,
	getDashboardData,
	getNewUsersCounts,
	getRegionLessonsUsersCounts,
	getRegionsUsersCounts,
	handleGetActiveNewUsersCountsSuccess,
	handleGetDashboardDataSuccess,
	handleGetRegionLessonsUsersCountsSuccess,
	handleGetRegionsUsersCountsSuccess,
} from './slice';

function* getDashboardDataHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const applicationContext = yield getContext('applicationContext');
		const dashboardService = yield new DashboardService(applicationContext);
		const resData = yield dashboardService.getAllStats();

		yield put(handleGetDashboardDataSuccess(resData));
	} catch (e) {}
}

function* getActiveUsersCountsHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const applicationContext = yield getContext('applicationContext');
		const dashboardService = yield new DashboardService(applicationContext);
		const resData = yield dashboardService.getActiveUsersCountsStats(
			action.payload.fromDate,
			action.payload.toDate,
		);

		yield put(handleGetActiveNewUsersCountsSuccess(resData));
	} catch (e) {}
}

function* getNewUsersCountsHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const applicationContext = yield getContext('applicationContext');
		const dashboardService = yield new DashboardService(applicationContext);
		const resData = yield dashboardService.getNewUsersCountsStats(
			action.payload.fromDate,
			action.payload.toDate,
		);

		yield put(handleGetActiveNewUsersCountsSuccess(resData));
	} catch (e) {}
}

function* getRegionsUsersCountsHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const applicationContext = yield getContext('applicationContext');
		const dashboardService = yield new DashboardService(applicationContext);
		const resData = yield dashboardService.getRegionsUsersCountsStats();

		yield put(handleGetRegionsUsersCountsSuccess(resData));
	} catch (e) {}
}

function* getRegionLessonsUsersCountsHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const applicationContext = yield getContext('applicationContext');
		const dashboardService = yield new DashboardService(applicationContext);
		const resData = yield dashboardService.getRegionLessonsUsersCountsStats(
			action.payload.region,
		);

		yield put(handleGetRegionLessonsUsersCountsSuccess(resData));
	} catch (e) {}
}

export function* dashboardSaga(): Generator<any, any, any> {
	yield all([takeEvery(getDashboardData, getDashboardDataHandler)]);
	yield all([takeEvery(getActiveUsersCounts, getActiveUsersCountsHandler)]);
	yield all([takeEvery(getNewUsersCounts, getNewUsersCountsHandler)]);

	yield all([takeEvery(getRegionsUsersCounts, getRegionsUsersCountsHandler)]);
	yield all([
		takeEvery(getRegionLessonsUsersCounts, getRegionLessonsUsersCountsHandler),
	]);
}
